
<div>
  <img class="schematicImage" [src]="sanitize(schematicData.Data)">

  <ng-container *ngFor="let cp of SchematicOP">
  
          <i class="material-icons button__icon component-dot"
            
             [class.red-eval]="getEval() == 'red'"            
             [class.component-dot2]="mouseoverOPId == cp.Id"
             matTooltip="{{cp.Name}} "
             [style]="getPosition(cp.PositionX, cp.PositionY)">lens</i>

             <i class="material-icons button__icon component-dot" *ngIf="cp.EndPositionX!=null"
               
               [class.red-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'red'"
               
               [class.component-dot2]="mouseoverOPId == cp.Id"
               matTooltip="{{cp.Name}}"
               [style]="getPosition(cp.EndPositionX, cp.EndPositionY)">lens</i>
     
             <div *ngIf="cp.EndPositionX!=null"  [style]="getLine(cp.PositionX, cp.PositionY,cp.EndPositionX, cp.EndPositionY,cp.IsCrackFixed)"></div>
    
      

</ng-container>
</div>

<!-- (mouseover)="onMouseOverOP(cp.Id)"
(mouseout)="onMouseOutOP(cp.Id)" -->